export const floatingLabels = {
  id: "floatingLabels",
  afterDatasetsDraw(chart) {
    if (chart.canvas.id == "my-chart-bar-percentage") {
      // console.log(chart);
      chart.ctx.save();

      const datasetArray = chart.data.datasets[0].data.map(
        (datapoint, index) => {
          if (datapoint > chart.data.datasets[1].data[index]) {
            return 0;
          } else {
            return 1;
          }
        }
      );

      const percentageArray = [
        // "28%",
        // "9%",
        // "61%",
        // "-2%",
        // "-2%",
        // "9%",
        // "32%",
        "47.2%",
        "13.2%",
        "9.1%",
        "4.7%",
        "3.1%",
        "-21.9%",
        "-22.6%",

      ];

      //  console.log(diffArray)

      datasetArray.forEach((value, index) => {
        chart.ctx.font = "bold 14px sans-serif";
        chart.ctx.fillStyle = "#666";
        chart.ctx.texAlign = "center";
        chart.ctx.fillText(
          percentageArray[index],
          chart.scales.x.getPixelForValue(index) - 15,
          chart.getDatasetMeta(datasetArray[index]).data[index].y - 10
        );
      });
    }
  },
};
